const CompanyHighlights = () => {
    return (
        <div className="CompanyHighlights">
            <div className="highlight">
                <span>Legal Services</span>
            </div>
            <div className="highlight">
                <span>Global Law Firm</span>
            </div>
            <div className="highlight">
                <span>$2.9B Revenue</span>
            </div>
        </div>
    );
};

export default CompanyHighlights;
